import React, { useEffect, useState } from 'react'
import { Formik, Field, Form, FieldArray, ErrorMessage } from 'formik';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import axios from 'axios';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { FaSave } from 'react-icons/fa';
import { AiFillDelete } from "react-icons/ai";
import { ToastContainer, toast } from 'react-toastify';

import { toastConfig } from '../../../../utils/ToastConfig'

const EVENT_URL = '/events'

const EventSchema = Yup.object().shape({
    title: Yup.string().min(3, 'too short').required('required'),
    event_date: Yup.date().min(new Date(), "Date cannot be in the past").required('required'),
    venue: Yup.string().min(3, 'too short').required('required'),
    description: Yup.string().min(10, 'too short').required('required'),
    registration_link: Yup.string().required('required'),
    collaborating_clubs: Yup.array().of(Yup.string().required('required'))
});

const EventUpdate = () => {
    let { id, eventid } = useParams();
    const navigate = useNavigate()
    const [clubToken, setClubToken] = useState('')
    const [gettingdata, setGettingdata] = useState(false)
    const [eventDetails, setEventDetails] = useState('')
    const [open, setOpen] = useState(false);
    const [previewImg, setPreviewImg] = useState()
    const [submitting, setSubmitting] = useState(false)

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const deleteEvent = async (id) => {
        try {
            await axios.delete(process.env.REACT_APP_DEPT_API + EVENT_URL + '/' + eventid + '/auth/delete', {
                headers: {
                    authorization: `Bearer ${clubToken}`
                }
            })
            alert("Deleted successfully")
            const clubId = localStorage.getItem('user_id')
            navigate(`/clubs/${clubId}/events`)
        } catch (err) {
            console.log(err)
            alert(err.response.data.message && err.response.data.message.message)
        }
    }

    const getData = async () => {
        setGettingdata(true)
        try {
            const response = await axios.get(process.env.REACT_APP_DEPT_API + EVENT_URL + '/' + eventid)
            setEventDetails(response.data)
            setGettingdata(false)
        } catch (err) {
            toast.error(err, toastConfig)
        }
    }
    useEffect(() => {
        async function checkAccess() {
            const clubToken = localStorage.getItem('club_token')
            const clubId = localStorage.getItem('user_id')
            if (!clubToken || clubId !== id) {
                alert('Acess denied')
                navigate('/')
            }
            setClubToken(clubToken)
        }
        checkAccess()
        getData()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setPreviewImg(eventDetails && eventDetails.poster_image.url)
    }, [eventDetails])

    return (
        <div className='admin'>
            <ToastContainer
                position="bottom-right"
                autoClose={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                theme="colored"
            />
            <div className='section__container'>
                <h1 className='section__header'>Update Event</h1>
                {!gettingdata && eventDetails ?
                    <Formik
                        initialValues={eventDetails}
                        enableReinitialize
                        validationSchema={EventSchema}
                        onSubmit={async (values) => {
                            setSubmitting(true)
                            const data = { club: id, ...values }
                            axios.put(process.env.REACT_APP_DEPT_API + EVENT_URL + '/' + eventid + '/auth/update', data, {
                                headers: {
                                    authorization: `Bearer ${clubToken}`
                                }
                            }).then(() => {
                                toast.success("Event Added Successfully", toastConfig)
                                setSubmitting(false)
                                setTimeout(() => {
                                    navigate(`/clubs/${id}`)
                                }, 2500)
                            }).catch(err => {
                                console.log(err)
                                alert(err.response.data.message && err.response.data.message.message)
                                setSubmitting(false)
                            })
                        }
                        }
                    >
                        {({ values, setFieldValue, errors, submitForm }) => (
                            <Form style={{ width: '100%' }}>
                                <div className='eventUpdate_btn_container'>
                                    <button type="button" className='admin_btn_update' disabled={submitting} onClick={
                                        () => {
                                            if (errors && Object.keys(errors).length !== 0) {
                                                toast.error("Could't Submit Form - Fix errors", toastConfig)
                                            }
                                            submitForm()
                                        }}>
                                        <FaSave /> {submitting ? "Saving..." : "Save Changes"}
                                    </button>
                                    <button className='admin_delete_btn' type="button" onClick={handleClickOpen}>
                                        <AiFillDelete /> Delete
                                    </button>
                                    <Dialog open={open} onClose={handleClose}>
                                        <DialogTitle>
                                            <span className='admin_modal_header'>Confirm Delete</span>
                                        </DialogTitle>
                                        <DialogContent>
                                            <div className='modal_btn_container'>
                                                <button className='admin_modal_btn cancel' onClick={handleClose}>Cancel</button>
                                                <button className='admin_modal_btn delete' onClick={() => deleteEvent(id)}>Delete</button>
                                            </div>
                                        </DialogContent>

                                    </Dialog>
                                </div>
                                <div className='cpu-container'>
                                    <div className='cpu-col1'>
                                        <div className='cpu-card cpu-personal-card'>
                                            <h2>Event Details</h2>
                                            <div className='cpu-personal-card-img'>
                                                <div className='admin_input_container'>
                                                    <p className="admin_label" htmlFor="updated_poster_image">Event Poster</p>
                                                    <div>
                                                        <img src={previewImg && previewImg} alt="poster" />
                                                    </div>
                                                    <label className='cpu-file-btn'>
                                                        <input className="admin_input" id="file" name="updated_poster_image" type="file" onChange={(e) => {
                                                            // converting image to base64 for cloudinary
                                                            const file = e.target.files[0]
                                                            const reader = new FileReader()
                                                            reader.readAsDataURL(file)
                                                            reader.onloadend = () => {
                                                                setFieldValue("updated_poster_image", reader.result)
                                                                setPreviewImg(reader.result)
                                                            }
                                                        }} />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="title">Event Title *</label>
                                                <Field className="admin_input" name="title" placeholder="Event Title" />
                                                <ErrorMessage name="title" component="div" className="field-error admin_error_msg" />
                                            </div>

                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="description">Description *</label>
                                                <Field className="admin_input" as="textarea" name="description" />
                                                <ErrorMessage name="description" component="div" className="field-error admin_error_msg" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='cpu-col2'>
                                        <div className='cpu-card cpu-personal-card'>
                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="event_date">Date of event *</label>
                                                <Field className="admin_input" name="event_date" type="date" />
                                                <ErrorMessage name="event_date" component="div" className="field-error admin_error_msg" />
                                            </div>
                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="registration_deadline">Registration deadline</label>
                                                <Field className="admin_input" name="registration_deadline" type="date" />
                                            </div>
                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="venue">Venue *</label>
                                                <Field className="admin_input" name="venue" />
                                                <ErrorMessage name="venue" component="div" className="field-error admin_error_msg" />
                                            </div>
                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="registration_link">Registration Link *</label>
                                                <Field className="admin_input" name="registration_link" />
                                                <ErrorMessage name="registration_link" component="div" className="field-error admin_error_msg" />
                                            </div>
                                        </div>
                                        <div className='cpu-card cpu-personal-card'>
                                            <div className='fpu-academic-row1-col'>
                                                <h4>Collaborating Clubs</h4>
                                                <FieldArray name="collaborating_clubs">
                                                    {({ insert, remove, push }) => (
                                                        <div>
                                                            {values && values.collaborating_clubs && values.collaborating_clubs.length > 0 &&
                                                                values.collaborating_clubs.map((member, index) => (
                                                                    <div className="fpu-academic-sub-row" key={index}>
                                                                        <div className="fpu-academic-sub-row-col1">
                                                                            <Field
                                                                                className="admin_input"
                                                                                name={`collaborating_clubs.${index}`}
                                                                                type="text" placeholder="Name of Club"
                                                                            />
                                                                            <ErrorMessage name={`collaborating_clubs.${index}`} component="div" className="field-error admin_error_msg" />
                                                                        </div>
                                                                        <div className="fpu-academic-sub-row-col2">
                                                                            <button
                                                                                type="button"
                                                                                className="secondary"
                                                                                onClick={() => remove(index)}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            <button
                                                                type="button"
                                                                className="fpu-add-btn"
                                                                onClick={() => push('')}
                                                            >
                                                                Add Club
                                                            </button>
                                                        </div>
                                                    )}
                                                </FieldArray>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    : <p>Loading...</p>}
            </div >
        </div>
    )
}

export default EventUpdate